/**
 * 营销管理-卡片页
 */
import React from 'react';
import PropTypes from 'prop-types';

class Card extends React.Component {
    
    componentDidMount() {
        this.props.history.replace({
            pathname: '/home/market/cardcentre'
        });
    }

    render() {
        return (
            <div></div>
        );
    }
}

Card.propTypes = {
    history: PropTypes.object, // 路由
};

export default Card;